import { colors, font } from "@literati/public-ui-shared-react";
import { css } from "styled-components";

export const primaryHeading = css`
  color: ${colors.inkBlack};
  text-align: center;
  font-family: ${font.fontFamily.hoefler};
  font-size: 1.5rem;
  line-height: 1.8rem;
`;

export const sectionHeading = css`
  color: ${colors.inkBlack};
  font-size: 0.875rem;
  font-weight: 700;
`;

export const sectionSubtext = css`
  color: ${colors.warmGray3};
  font-size: 0.875rem;
`;
